export type SelectOption = {
  key: string;
  displayLabel: string;
};

export enum NodeType {
  String = 'string',
  Date = 'date',
  Boolean = 'boolean',
  File = 'file',
  Select = 'select',
  Group = 'group',
  Array = 'array'
}

export type StringPresentation = {
  nodeType: NodeType.String;
  label: string;
  applicantLabel: string;
  value: string | null;
};

export type DatePresentation = {
  nodeType: NodeType.Date;
  label: string;
  applicantLabel: string;
  value: string | null;
};

export type BooleanPresentation = {
  nodeType: NodeType.Boolean;
  label: string;
  applicantLabel: string;
  value: boolean | null;
};

export type FilePresentation = {
  nodeType: NodeType.File;
  label: string;
  applicantLabel: string;
  fileId: string | null;
  fileName: string | null;
  url: string | null;
  description: string | null;
};

export type SelectPresentation = {
  nodeType: NodeType.Select;
  label: string;
  applicantLabel: string;
  selectedDisplayLabel: string | null;
  options: SelectOption[];
};

export type GroupPresentation = {
  nodeType: NodeType.Group;
  label: string;
  applicantLabel: string;
  children: Record<string, PresentationNode>;
};

export type ArrayPresentation = {
  nodeType: NodeType.Array;
  label: string | null;
  applicantLabel: string | null;
  items: PresentationNode[];
};

export type PresentationNode =
  | StringPresentation
  | DatePresentation
  | BooleanPresentation
  | FilePresentation
  | SelectPresentation
  | GroupPresentation
  | ArrayPresentation;

export function isNodeEmpty(node: PresentationNode): boolean {
  switch (node.nodeType) {
    case NodeType.String:
    case NodeType.Date:
      return node.value === null || node.value === '' || node.value === ' ';
    case NodeType.Boolean:
      return node.value === null;
    case NodeType.Select:
      return node.selectedDisplayLabel === null;
    case NodeType.File:
      return node.fileId === null;
    case NodeType.Group:
      return Object.values(node.children).every(isNodeEmpty);
    case NodeType.Array:
      return node.items.length === 0 || node.items.every(isNodeEmpty);
  }
}
